import { render, staticRenderFns } from "./add-income-modal.vue?vue&type=template&id=6d0f76e4"
import script from "./add-income-modal.vue?vue&type=script&lang=js"
export * from "./add-income-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports